// @/utils/api/fetchPlaylist.ts
import { objectToParamsQuery } from '@/utils'
import settings from '@/settings/public'

export const fetchPlaylist = async ({
  id,
  pageParam = 1,
  options,
}: {
  id: string
  pageParam: number
  options?: { params?: Record<string, any> }
}) => {
  const queryString = objectToParamsQuery(options?.params || {})

  const url = `${settings.api.host}/api/generic/playlists?id=${id}&${
    queryString ? `${queryString}` : 'sortByAsc=order'
  }&page=${pageParam}`

  try {
    const response = await fetch(url)
    if (!response.ok) {
      throw new Error(`Failed to fetch playlist ${id}: ${response.status} ${response.statusText}`)
    }
    const playlistJson = await response.json()
    return playlistJson
  } catch (error: any) {
    console.error('Error fetching playlist:', error)
    throw new Error(`Playlist fetch failed: ${error.message}`)
  }
}